<template>
  <header class="header-component">
    <dx-toolbar class="header-toolbar">
      <dx-item
        :visible="menuToggleEnabled"
        location="before"
        css-class="menu-button"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <dx-button
          slot-scope="_"
          icon="menu"
          styling-mode="text"
          @click="toggleMenuFunc"
        />
        <!--eslint-enable-->
      </dx-item>

      <dx-item
        v-if="title"
        location="before"
        css-class="header-title dx-toolbar-label"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <div slot-scope="_">
          <a class="header-title dx-toolbar-label" href="/gateways">{{
            title
          }}</a>
        </div>
        <!--eslint-enable-->
      </dx-item>
      <dx-item
        location="after"
        locate-in-menu="auto"
        menu-item-template="menuUserItem"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <div slot-scope="_">
          <dx-button
            class="user-button authorization"
            height="100%"
            styling-mode="text"
          >
            <user-panel :menu-items="userMenuItems" menu-mode="context" />
          </dx-button>
        </div>
        <!--eslint-enable-->
      </dx-item>

      <dx-item
        location="after"
        locate-in-menu="auto"
        menu-item-template="menuUserItem"
      >
        <div class="time-zone">{{ getUserTimeZone() }}</div>
      </dx-item>
      <!-- eslint-disable vue/no-unused-vars -->
      <user-panel
        slot="menuUserItem"
        slot-scope="_"
        :menu-items="userMenuItems"
        menu-mode="list"
      />
      <!--eslint-enable-->
    </dx-toolbar>
  </header>
</template>

<script>
import { getUserTimeZone } from '../utils/time'
import DxButton from 'devextreme-vue/button'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import UserPanel from './user-panel'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    DxButton,
    DxToolbar,
    DxItem,
    UserPanel,
  },
  props: {
    menuToggleEnabled: Boolean,
    title: { type: String, required: true },
    toggleMenuFunc: { type: Function, required: true },
  },
  data() {
    return {
      userMenuItems: [
        {
          text: 'Logout',
          onClick: this.logout,
        },
      ],
    }
  },
  computed: {
    ...mapState('user', ['profile']),
  },
  mounted() {},
  methods: {
    ...mapActions('user', ['logout']),
    getUserTimeZone,
  },
}
</script>

<style lang="scss">
@import '../themes/generated/variables.base.scss';
@import 'src/styles/global';

div.time-zone {
  font-size: 14px;
  color: $base-text-color;
  margin-bottom: 7px;
}

.header-component {
  flex: 0 0 auto;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: $base-accent;
  }
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
  padding: 0 40px;

  .screen-x-small & {
    padding: 0 20px;
  }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
  width: $side-panel-min-width;
  text-align: center;
  padding: 0;
}

.header-title .dx-item-content {
  padding: 0;
  margin: 0;
}

.dx-theme-generic {
  .dx-toolbar {
    padding: 10px 0;
  }

  .user-button > .dx-button-content {
    padding: 3px;
  }
}
</style>
